import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import PlannerModuleForm from '../containers/PlannerModuleFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class PlannerModuleEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `PlannerModuleEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('planner_module_route_edit')} />
          <PlannerModuleForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default PlannerModuleEditScreen;

Logger.log('silly', `PlannerModuleEditScreen loaded.`);
